/**
 * Decode a JWT payload without signature verification.
 *
 * Handles base64url encoding (URL-safe chars + missing padding)
 * that standard `atob()` does not support directly.
 */
export function jwtDecode<T = Record<string, unknown>>(token: string): T {
  const [, payload] = token.split('.');

  if (!payload) {
    throw new Error('Invalid JWT: missing payload segment');
  }

  const normalized = payload.replace(/-/g, '+').replace(/_/g, '/');
  const padded = normalized + '='.repeat((4 - (normalized.length % 4)) % 4);

  return JSON.parse(atob(padded)) as T;
}
